var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-product-category-refinements" }, [
    _c(
      "div",
      {
        staticClass:
          "wf-product-refinement-list wf-product-refinement-list-expanded"
      },
      [
        _c("div", { staticClass: "wf-product-refinement-list-header" }, [
          _c(
            "button",
            {
              staticClass: "btn wf-product-refinement-list-header-toggle",
              attrs: {
                type: "button",
                "data-toggle": "collapse",
                "data-target": ".wf-product-refinement-collapse-paint"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$resourceString["benjaminMoore.Filter.Color"]) +
                  "\n        "
              ),
              _c("span", {
                staticClass:
                  "\n              png-icon\n              png-icon-icons-glyph--k-btn-minus-active\n              wf-product-refinement-list-header-toggle-inactive\n            "
              }),
              _vm._v(" "),
              _c("span", {
                staticClass:
                  "\n              png-icon\n              png-icon-icons-glyph--k-btn-expand-ol\n              wf-product-refinement-list-header-toggle-active\n            "
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "wf-product-refinement-list-items collapse show",
            class: "wf-product-refinement-collapse-paint"
          },
          [
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "\n              wf-product-refinement-list-item row m-2\n            "
                },
                _vm._l(_vm.colorsMap, function(item) {
                  return _c("div", {
                    key: item.hex,
                    class: [
                      "benjamin-paint",
                      _vm.selectedColor && _vm.selectedColor.includes(item.key)
                        ? "active"
                        : ""
                    ],
                    style: { backgroundColor: item.hex },
                    on: {
                      click: function($event) {
                        return _vm.colorFilter(item.key)
                      }
                    }
                  })
                }),
                0
              )
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "info-text-on-left-side" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["benjaminMoore.Filter.info"]) +
          "\n  "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }